import { ModelSagres } from "../../model-sagres";
import { NormativoCargo } from "./normativo-cargo";

export class CargoCriar extends ModelSagres {
  codigoCargo: string;
  nomenclaturaCargo: string;
  vinculo: number | null;
  regimeJuridico: number | null;
  regimePrevidenciario: number | null;
  especialidade: number | null;
  area: number | null;
  escolaridade: number | null;
  habilitacaoExigida: string;
  naturezaCargo: number | null;
  idadeMinima: number | null;
  idadeMaxima: number | null;
  quantidadeVagas: string;
  situacaoCargo: number | null;
  tetoRemuneratorioEspecifico: number | null;
  cargaHoraria: number | null;
  possuiNormativo: "S" | "N";
  normativo: NormativoCargo;

  constructor(obj?: any) {
    super();
    this.codigoCargo = obj?.codigoCargo ?? "";
    this.nomenclaturaCargo = obj?.nomenclaturaCargo ?? "";
    this.vinculo = obj?.vinculo ?? null;
    this.regimeJuridico = obj?.regimeJuridico ?? null;
    this.regimePrevidenciario = obj?.regimePrevidenciario ?? null;
    this.especialidade = obj?.especialidade ?? null;
    this.area = obj?.area ?? null;
    this.escolaridade = obj?.escolaridade ?? null;
    this.habilitacaoExigida = obj?.habilitacaoExigida ?? "";
    this.naturezaCargo = obj?.naturezaCargo ?? null;
    this.idadeMinima = obj?.idadeMinima ?? null;
    this.idadeMaxima = obj?.idadeMaxima ?? null;
    this.quantidadeVagas = obj?.quantidadeVagas ?? "";
    this.situacaoCargo = obj?.situacaoCargo ?? null;
    this.tetoRemuneratorioEspecifico = obj?.tetoRemuneratorioEspecifico ?? null;
    this.cargaHoraria = obj?.cargaHoraria ?? null;
    this.possuiNormativo = obj?.possuiNormativo ?? "N";
    this.normativo = new NormativoCargo(obj?.normativo);
  }
}
